import React, { useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { ImageElement } from "../../../components";

function AuthSidebar({navbar}) {  
    useEffect(() =>{
        setTimeout(() => {
            document.querySelector(".sideBar").style.top = `${navbar}px`;
            document.querySelector(".sideBar").style.height = `${window.innerHeight - navbar}px`;
          }, 300);
    })
  return (
    <aside className="sideBar bg-white d-flex flex-column">
        <ul className="list-unstyled sideBar_menu">
            <li>
                <NavLink  to="/terms-conditions"><em className="gg-terms"></em> Terms of use</NavLink>
            </li>
            <li>
                <NavLink to="/privacy-policy"><em className="gg-policy"></em> Privacy Policy</NavLink>
            </li>
            <li>
                <NavLink to="/aboutus"><em className="gg-about-us"></em> About us</NavLink>
            </li>
            <li>
                <NavLink to="/faqs"><em className="gg-faq"></em> FAQ</NavLink>
            </li>
        </ul>
        <div className="sideBar_bottom">
            <p className="text-center">Meet the new Good Guys Service  <br /> Mobile app</p>
            <Link><ImageElement source="google-play-logo.svg" alt="Google-play" /></Link>
            <Link><ImageElement source="app-store-logo.svg" alt="App-play" /></Link>
        </div>
    </aside>
  );
}
  
export default AuthSidebar;